import { useState } from "react";
import { format, parseISO } from "date-fns";
import { it } from "date-fns/locale";
import { CalendarDays } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const cls = "w-full border border-slate-200 rounded-md px-3 py-2 text-sm bg-white text-left " +
  "hover:border-slate-400 focus:outline-none focus:ring-2 focus:ring-slate-300 transition-colors duration-200";

/** Campo data con calendario a scomparsa: oggi evidenziato, nessuna data futura. */
export function SelettoreData({ value, onChange, testId, disabled, error, compatto }) {
  const [aperto, setAperto] = useState(false);
  const selezionata = value ? parseISO(value) : undefined;

  return (
    <Popover open={aperto} onOpenChange={setAperto}>
      <PopoverTrigger asChild>
        <button type="button" disabled={disabled} data-testid={testId}
          className={`${cls} flex items-center gap-2 ${error ? "!border-red-500 ring-2 ring-red-200" : ""}
            ${disabled ? "bg-slate-100 text-slate-400" : ""} ${compatto ? "!w-auto !px-2.5 !py-1.5" : ""}`}>
          <CalendarDays size={15} className="text-slate-400 shrink-0" />
          <span className={value ? "text-slate-800" : "text-slate-400"}>
            {value ? format(selezionata, "dd/MM/yyyy") : (compatto ? "gg/mm/aaaa" : "Seleziona data")}
          </span>
        </button>
      </PopoverTrigger>
      <PopoverContent
        className="w-auto p-2 z-[1300] bg-white border-2 border-slate-300 shadow-2xl rounded-lg opacity-100"
        align="start" data-testid={`${testId}-calendario`}>
        <Calendar mode="single" locale={it} selected={selezionata} defaultMonth={selezionata || new Date()}
          today={new Date()} disabled={{ after: new Date() }}
          modifiersClassNames={{ today: "!rounded-full ring-2 ring-sky-500 font-bold text-sky-700",
            selected: "!rounded-full bg-slate-900 text-white" }}
          className="bg-white [&_.rdp-day]:text-slate-800 [&_.rdp-head_cell]:text-slate-500
            [&_.rdp-caption_label]:font-semibold [&_.rdp-caption_label]:text-slate-900"
          onSelect={(d) => {
            if (d) onChange(format(d, "yyyy-MM-dd"));
            setAperto(false);
          }} />
      </PopoverContent>
    </Popover>
  );
}
